import { SpacedForwardSlash, TooltippedIcon } from '@mews-commander/ui';
import { LocalizedPercent, lt } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { IconName, Position, Stack, Typography } from '@optimus-web/core';
import { DatavizColor } from '@mews/b2b-ui';
import { useFormAbsoluteLimitValue } from '../form';
import { LimitsProgressChart } from './LimitsProgressChart';

export interface ResourceInfoProps {
    availableResources: number;
    isFormVisible: boolean;
    occupancy: number;
    sold: number;
}

export const ResourceInfo = ({ occupancy, sold, availableResources, isFormVisible }: ResourceInfoProps) => {
    const absolutePerTimeUnitLimit = useFormAbsoluteLimitValue();
    let chartColor: DatavizColor = 'green';

    const hasLimitReached = isFormVisible ? sold === absolutePerTimeUnitLimit : false;
    const hasLimitExceeded = isFormVisible ? sold > absolutePerTimeUnitLimit : false;

    if (hasLimitReached) {
        chartColor = 'orange';
    } else if (hasLimitExceeded) {
        chartColor = 'red';
    }

    return (
        <Stack spacing="200" vertical>
            <Stack spacing="50" vertical>
                <Stack spacing="200" distribution="space-between">
                    <Typography textStyle="bodyMedium" as="div">
                        {lt('HouseOccupancy')}
                    </Typography>
                    <Typography textStyle="bodyMedium" as="div">
                        <LocalizedPercent percent={occupancy} options={{ precision: 2 }} />
                    </Typography>
                </Stack>
                <Stack spacing="200" distribution="space-between">
                    <Typography textStyle="bodyMedium" as="div">
                        {lt('AvailableSpacePlural')}
                    </Typography>
                    <Typography textStyle="bodyMedium" as="div">
                        {availableResources}
                    </Typography>
                </Stack>
                <Stack spacing="200" distribution="space-between" itemAlignment="end">
                    <Typography textStyle="bodyMedium" as="div">
                        {lt('SpacesSold')}
                    </Typography>
                    <Stack spacing="50" itemAlignment="end">
                        {hasLimitReached || hasLimitExceeded ? (
                            <TooltippedIcon
                                tooltip={TextKey.DailyLimitReached}
                                value={IconName.Problematic}
                                iconVariant={hasLimitExceeded ? 'danger' : 'warning'}
                                tooltipPosition={Position.Top}
                            />
                        ) : null}
                        <Typography textStyle="bodyMedium" as="div">
                            {sold}
                            {isFormVisible ? SpacedForwardSlash + absolutePerTimeUnitLimit : null}
                        </Typography>
                    </Stack>
                </Stack>
            </Stack>
            {isFormVisible ? (
                <LimitsProgressChart total={absolutePerTimeUnitLimit} value={sold} color={chartColor} />
            ) : null}
        </Stack>
    );
};
